export default "__VITE_ASSET__3a35b2e6__"